import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { useDispatch } from "react-redux";
import { Button, Col, Form, Table, Image, Modal, Row } from "react-bootstrap";
import LeftSideNavigation from "../../../vendorDashboardComponents/navigationSection/LeftSideNavigation";
import HomeReusableTopBarNavigation from "../../superAdminReusable/superAdminHomeButton/HomeReusableTopBarNavigation";
import AddOpenIssuesVendor from "./InsideAllPageComponent/AddOpenIssuesVendor";
import StatusModal from "./ViewVendorsTickets/StatusModal";
import { getAllCateogryForIcons } from "../../../../store/actions/SuperAdminActions/adminCategoryAndIconsAction";
//import { SuperAdminVendorIssueTableBody } from "./SuperAdminVendorIssueTableBody";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import Menu from "@material-ui/core/Menu";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { clear_all_errors } from "../../../../store/actions/errorActions";
import {
  superadmin_vendor_open_issue,
  superadmin_vendor_Single_open_issue,
  update_super_admin_open_issues,
} from "../../../../store/actions/SuperAdminActions/adminPendingActiveDinersAction";
import isEmpty from "../../../../store/validation/is-Empty";
import { AmealioLoader } from "../../../Loader/AmealioLoader";
import MenuItem from "@material-ui/core/MenuItem";
import { FormControl, Select, InputLabel, TextField } from "@material-ui/core";
import { BodyData } from "./InsideAllPageComponent/BodyData";
import SelectFilter from "../../../reusableComponents/selectFilter";
import BasicPagination from "../../../Pagination/Pagination";
import CSVDownloader from "../../../reusableComponents/csvDownload/csvDownload";
import NoContent from "../../../reusableComponents/NoContentComponent";

const SuperAdminOpenIssuesVendor = (props) => {
  //state
  let history = useHistory();
  const dispatch = useDispatch();

  const [loading, setLoading] = useState(false);
  const [selectedTab, setSelectedTab] = useState(0);
  const [search, setSearch] = useState("");
  const [dateQuery, setDateQuery] = useState({});

  const pageChangeButtonHandler = (value) => {
    setSelectedTab(value);
    setFilter({
      ...filter,
      category: "",
      status: "",
      type: "",
      search: false,
    });
  };

  const calcStatus = (status) => {
    if (status === 0) {
      return "New";
    } else if (status === 1) {
      return "In-Progress";
    } else if (status === 2) {
      return "Awaiting Feedback";
    } else if (status === 3) {
      return "On Hold";
    } else if (status === 4) {
      return "Re-Opened";
    } else if (status === 5) {
      return "Resolved";
    } else if (status === 6) {
      return "Closed";
    } else if (status === 7) {
      return "Archive";
    } else if (status === 8) {
      return "Pending";
    } else if (status === 9) {
      return "Communicated";
    } else if (status === 10) {
      return "Uploaded";
    } else if (status === 11) {
      return "";
    }
  };

  const onSuccessChangeTicketStatus = () => {
    const token = props.auth.user.accessToken;
    props.superadmin_vendor_open_issue(
      selectedTab,
      { ...dateQuery },
      token,
      onSuccessGetAllTickets
    );
    onCloseModal();
  };
  const onErrorChangeTicketStatus = () => {
    onCloseModal();
  };

  const onSubmitHandler = (e) => {
    const token = props.auth.user.accessToken;
    const formData = {};
    formData.status = currentStatus;
    props.update_super_admin_open_issues(
      formData,
      token,
      ticketId,
      onSuccessChangeTicketStatus,
      onErrorChangeTicketStatus
    );
  };

  const onSuccessGetAllTickets = () => {
    setLoading(false);
  };
  const updateLatest = () => {
    const token = props.auth.user.accessToken;
    props.superadmin_vendor_open_issue(
      selectedTab,
      { ...dateQuery },
      token,
      onSuccessGetAllTickets
    );
  };

  useEffect(() => {
    dispatch(getAllCateogryForIcons(onSuccessGetFavChain));
  }, []);

  useEffect(() => {
    setLoading(true);
    if (!isEmpty(dateQuery)) {
      const token = props.auth.user.accessToken;
      props.superadmin_vendor_open_issue(
        selectedTab,
        { ...dateQuery },
        token,
        onSuccessGetAllTickets
      );
    }
  }, [selectedTab]);

  const [modalStatus, setModalStatus] = useState(false);
  const onCloseModal = () => {
    setModalStatus(false);
  };

  const [currentStatus, setCurrentStatus] = useState(0);
  const statusTypes = [
    { name: "All", status: 11 },
    { name: "New", status: 0 },
    { name: "In-Progress", status: 1 },
    { name: "Awaiting Feedback", status: 2 },
    { name: "On Hold", status: 3 },
    { name: "Re-Opened", status: 4 },
    { name: "Resolved", status: 5 },
    { name: "Closed", status: 6 },
    { name: "Archive", status: 7 },
    { name: "Pending", status: 8 },
    { name: "Communicated", status: 9 },
    { name: "Uploaded", status: 10 },
  ];
  const [ticketId, setTicketId] = useState();
  const [showFilter, setShowFilter] = useState(false);
  const [sort, setSort] = useState("LATEST");
  const [category, setCategory] = useState([]);
  const onSuccessGetFavChain = (data) => {
    var cateogryIcons = [];
    for (var i = 0; i < data.length; i++) {
      cateogryIcons.push({ name: data[i].title, id: data[i]._id });
    }
    setCategory(cateogryIcons);
  };

  const [filter, setFilter] = useState({
    category: "",
    status: 11,
    type: "",

    categoryText: "",
    statusText: 11,
    typeText: "",
    search: false,
  });

  const [anchorEl, setAnchorEl] = React.useState(null);
  const handleClose = () => {
    setAnchorEl(null);
  };
  const [page, setPage] = useState(1);
  const [start, setStart] = useState(0);
  const [end, setEnd] = useState(10);
  const onShowModal = (status, ticketId) => {
    setCurrentStatus(status);
    setTicketId(ticketId);
    setModalStatus(true);
  };

  const onChangeTempStatus = (status) => {
    setCurrentStatus(status);
  };

  const onSearchChangeAction = (filterData) => {
    setFilter({
      ...filter,
      categoryText: filter.category,
      statusText: filter.status,
      typeText: filter.type,
    });
    console.log(filterData);
  };

  let filterSearch = props.admin_vendors_issue.filter((item) => {
    return (
      // (item && item.issue_title.toLowerCase().includes(search)) ||
      item.issue_id.toLowerCase().includes(search) ||
      (item.restaurant_id &&
        item.restaurant_id.restaurant_name.toLowerCase().includes(search))
    );
  });

  // if (filter.search) {
  if (filter.categoryText)
    filterSearch = filterSearch.filter((item) => {
      return item.category?.category_name === filter.categoryText;
    });
  if (filter.statusText === 11) {
    filterSearch = filterSearch;
  } else {
    filterSearch = filterSearch.filter((item) => {
      return item.status === filter.statusText;
    });
  }
  if (filter.typeText)
    filterSearch = filterSearch.filter((item) => {
      return item.type === filter.typeText;
    });
  // }
  if (sort === "LETEST")
    filterSearch = filterSearch.sort(
      (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
    );
  if (sort === "OLDEST")
    filterSearch = filterSearch.sort(
      (a, b) => new Date(a.createdAt) - new Date(b.createdAt)
    );

  const sendInformationViewIssues = (id) => (e) => {
    const issueId = id;
    const token = props.auth.user.accessToken;
    dispatch(
      superadmin_vendor_Single_open_issue(
        issueId,
        token,
        onSuccessIssue(issueId)
      )
    );
  };

  const onSuccessIssue = (issueId) => (e) => {
    history.push({
      pathname: `/adminopenissuesviewvendors/${issueId}`,
      state: { issuesId: issueId },
    });
  };

  const onIssueProfile = (data) => (e) => {
    console.log(data);
  };

  const handleBatchChange = (pageNo) => {
    window.scrollTo(0, 0);
    var calcStart = pageNo * 10 - 10;
    setStart(calcStart);
    setEnd(pageNo * 10);
    setPage(pageNo);
  };

  // const renderVendorOpenIssueTablebody = () => {
  //   if (!isEmpty(getAllData)) {
  //     return getAllData.map((data, index) => (
  //       <React.Fragment key={index}>
  //         <SuperAdminVendorIssueTableBody
  //           no={++index}
  //           vendorIssues={data}
  //           statusDropDownText={data.status}
  //           handleShowStatusList={handleShowStatusList}
  //           open={open}
  //           handleCloseStatusList={handleCloseStatusList}
  //           handleStatusChange={handleStatusChange}
  //           viewTicket={sendInformationViewIssues(data._id)}
  //           // editTicket={this.sendInformationEditTicket(data)}
  //         />
  //       </React.Fragment>
  //     ));
  //   }
  // };

  const appendSuggestionNew = () => {
    const token = props.auth.user.accessToken;
    props.superadmin_vendor_open_issue(
      selectedTab,
      { ...dateQuery },
      token,
      onSuccessGetAllTickets
    );
  };

  const onDateChangeHandler = () => (data, type) => {
    setDateQuery(data);
    setLoading(true);
    const token = props.auth.user.accessToken;
    props.superadmin_vendor_open_issue(
      selectedTab,
      { ...data },
      token,
      onSuccessGetAllTickets
    );
  };

  let profile = "";

  // download data

  const downloadData = {
    headers: [
      { label: "Issue  ID/ \n Issue No", key: "issueID" },
      { label: "Restaurant Name & ID", key: "resname" },
      { label: "Created By", key: "created" },
      { label: "Title", key: "title" },
      { label: "Category Name", key: "category" },
      { label: "Description", key: "description" },
      { label: "Status", key: "status" },
      { label: "Issues / \n Suggestion", key: "issue_suggestion" },
      ,
    ],
    data: filterSearch
      ? filterSearch?.map((ele) => {
        return {
          issueID: ele?.issue_id,
          resname: `${ele?.restaurant_id?.restaurant_name || ""} \n ${ele?.restaurant_id?.city || ""
            }`,
          created: `${ele?.createdBy?.name || ""} \n ${ele?.createdBy?.role || ""
            }`,
          title: `${ele?.issue_title || ""}`,
          category: ele?.category?.category_name || "",
          description: `${ele?.comment || ""}`,
          status: `${calcStatus(ele.status)}`,
          issue_suggestion: ele?.type,
        };
      })
      : [],
  };

  return (
    <React.Fragment>
      {!loading ? <></> : <AmealioLoader />}
      <div className="container-fluid">
        <div className="row">
          <div className="left-side-panel">
            <LeftSideNavigation displayLink={1} />
          </div>
          <div className="super-admin-right-side-panel">
            <HomeReusableTopBarNavigation />
            <div className="super-admin-inside-right-side-panel">
              <div className="d-flex justify-content-between align-items-center pt-4 pb-3">
                <div className="f24_700_HelveticaNeue">
                  Open Issues and Suggestions - Vendor
                </div>
                <AddOpenIssuesVendor
                  appendSuggestionNew={appendSuggestionNew}
                  actionBy="addIssue"
                  category={category}
                />
              </div>
              <Row className="mt-3 mb-3">
                <Col md={4}>
                  <Form.Control
                    type="text"
                    placeholder="Search"
                    className="amSearch"
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                  />
                </Col>
                <div className="col-3"></div>
                <div className="col-3">
                  <div className="mr-3">
                    <SelectFilter onDateChange={onDateChangeHandler()} />
                  </div>
                </div>
                <div className="col-2">
                  <div className="d-flex align-items-center justify-content-between">
                    <div
                      className="f10-400"
                      align="center"
                      aria-controls="simple-menu"
                      aria-haspopup="true"
                      onClick={(e) => {
                        setAnchorEl(e.currentTarget);
                      }}
                    >
                      <img
                        src={require("../../../../assets/images/iconButton/sorticon.png")}
                        width="35px"
                        alt="icon"
                      />
                      <br />
                      Sort
                    </div>

                    <div
                      className="f10-400"
                      align="center"
                      onClick={() => setShowFilter(!showFilter)}
                    >
                      <img
                        src={require("../../../../assets/images/iconButton/filtericon.png")}
                        width="35px"
                        alt="icon"
                      />
                      <br />
                      Filter
                    </div>
                    <div className="f10-400" align="center">
                      <CSVDownloader
                        filename={
                          selectedTab === 0
                            ? " New Open Issues and Suggestions Report"
                            : selectedTab === 1
                              ? " In-process Open Issues and Suggestions Report"
                              : selectedTab === 6
                                ? " Clodes Open Issues and Suggestions Report"
                                : "All Issues and Suggestions Report"
                        }
                        headers={downloadData.headers}
                        data={downloadData.data}
                      />
                    </div>
                  </div>
                </div>
              </Row>
              <Menu
                id="simple-menu"
                anchorEl={anchorEl}
                keepMounted
                open={Boolean(anchorEl)}
                onClose={handleClose}
              >
                <MenuItem
                  onClick={() => {
                    setSort("LATEST");
                    setAnchorEl(null);
                  }}
                >
                  Latest
                </MenuItem>
                <MenuItem
                  onClick={() => {
                    setSort("OLDEST");
                    setAnchorEl(null);
                  }}
                >
                  Oldest
                </MenuItem>
              </Menu>
              {showFilter && (
                <div
                  className="container-fluid p-4"
                  style={{
                    backgroundColor: "#ffffff",
                    transition: "height 2s",
                  }}
                >
                  <Row>
                    <Col md={6}>
                      <Form.Group>
                        <FormControl variant="outlined" className="w-100">
                          <InputLabel htmlFor="outlined-Status">
                            Category Name
                          </InputLabel>
                          <Select
                            value={filter.category}
                            onChange={(e) =>
                              setFilter({ ...filter, category: e.target.value })
                            }
                            label="Category Name"
                            inputProps={{
                              name: "Category Name",
                              id: "outlined-Status",
                            }}
                            IconComponent={KeyboardArrowDownIcon}
                          >
                            {category.map((item, index) => (
                              <MenuItem
                                label={item.name}
                                value={item.name}
                                key={item._id + index}
                              >
                                {item.name}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      </Form.Group>
                    </Col>
                    {selectedTab === 11 ? (
                      <Col md={6}>
                        <Form.Group>
                          <FormControl variant="outlined" className="w-100">
                            <InputLabel htmlFor="outlined-Status">
                              Status
                            </InputLabel>
                            <Select
                              value={filter.status}
                              onChange={(e) =>
                                setFilter({ ...filter, status: e.target.value })
                              }
                              label="Status"
                              inputProps={{
                                name: "Status",
                                id: "outlined-Status",
                              }}
                              IconComponent={KeyboardArrowDownIcon}
                            >
                              {statusTypes.map((type) => (
                                <option type="button" value={type.status}>
                                  {type.name}
                                </option>
                              ))}
                            </Select>
                          </FormControl>
                        </Form.Group>
                      </Col>
                    ) : (
                      <React.Fragment></React.Fragment>
                    )}
                    <Col md={6}>
                      <Form.Group>
                        <FormControl variant="outlined" className="w-100">
                          <InputLabel htmlFor="outlined-Status">
                            Type
                          </InputLabel>
                          <Select
                            value={filter.type}
                            onChange={(e) =>
                              setFilter({ ...filter, type: e.target.value })
                            }
                            label="Type"
                            inputProps={{
                              name: "Type",
                              id: "outlined-Status",
                            }}
                            IconComponent={KeyboardArrowDownIcon}
                          >
                            <option type="button" value={"ISSUE"}>
                              Issue
                            </option>
                            <option type="button" value={"SUGGESTION"}>
                              Suggestion
                            </option>
                          </Select>
                        </FormControl>
                      </Form.Group>
                    </Col>
                  </Row>
                  <div className="mt-5 d-flex">
                    <button
                      type="button"
                      className="onboarding_button_link_reusable onboarding_button_link_reusable_white mr-3"
                      title="Cancel Button"
                      onClick={() => {
                        setFilter({
                          ...filter,
                          category: "",
                          status: "",
                          type: "",
                          search: false,
                        });
                        setShowFilter(!showFilter);
                      }}
                    >
                      Cancel
                    </button>
                    <button
                      type="button"
                      className="onboarding_button_link_reusable onboarding_button_link_reusable_red"
                      title="Confirm Button"
                      // onClick={() => {
                      //   setFilter({ ...filter, search: true });
                      //   setShowFilter(!showFilter);
                      // }}
                      onClick={() => onSearchChangeAction(filter)}
                    >
                      Search
                    </button>
                  </div>
                </div>
              )}

              <div className="row align-items-center justify-content-between">
                <div className="col-md-6 d-flex align-items-center">
                  <Button
                    variant="link"
                    className={`px-0 mr-4 text-grayLink f12-500 ${selectedTab === 0 ? "active" : ""
                      }`}
                    onClick={(e) => pageChangeButtonHandler(0)}
                  >
                    New
                  </Button>
                  <Button
                    variant="link"
                    className={`px-0 mr-4 text-grayLink f12-500 ${selectedTab === 1 ? "active" : ""
                      }`}
                    onClick={(e) => pageChangeButtonHandler(1)}
                  >
                    In-Process
                  </Button>
                  <Button
                    variant="link"
                    className={`px-0 mr-4 text-grayLink f12-500 ${selectedTab === 6 ? "active" : ""
                      }`}
                    onClick={(e) => pageChangeButtonHandler(6)}
                  >
                    Closed
                  </Button>
                  <Button
                    variant="link"
                    className={`px-0 mr-4 text-grayLink f12-500 ${selectedTab === 11 ? "active" : ""
                      }`}
                    onClick={(e) => pageChangeButtonHandler(11)}
                  >
                    All
                  </Button>
                </div>
              </div>
              <div className="col-12 p-0 user-table-reusable-superadmin table-responsive">
                <Table className="enOpenTicketsUsers HideShowTable">
                  <thead>
                    <tr className="super_admin_all_users_table_head">
                      <th className="f12-700" style={{ width: "8%" }}>
                        Issue ID/ <br />
                        Issue No
                      </th>
                      <th className="f12-700" style={{ width: "18%" }}>
                        Restaurant <br />
                        Name & ID
                      </th>
                      <th className="f12-700" style={{ width: "15%" }}>
                        Created By
                      </th>
                      <th className="f12-700" style={{ width: "12%" }}>
                        Title
                      </th>
                      <th className="f12-700" style={{ width: "12%" }}>
                        Category <br />
                        Name
                      </th>
                      <th className="f12-700" style={{ width: "15%" }}>
                        Description
                      </th>
                      <th className="f12-700" style={{ width: "10%" }}>
                        Status
                      </th>
                      <th className="f12-700" style={{ width: "10%" }}>
                        Issues/ <br />
                        Suggestion
                      </th>
                    </tr>
                  </thead>
                  {filterSearch.length ? filterSearch
                    .slice(start, end)
                    .map(
                      (issue, index) => (
                        (profile =
                          issue &&
                          issue.restaurant_id &&
                          issue.restaurant_id.point_of_contact.filter(
                            (data) => data.defaultChecked === true
                          )),
                        (
                          <BodyData
                            key={issue._id}
                            profile={profile}
                            issue={issue}
                            appendSuggestionNew={appendSuggestionNew}
                            sendInformationViewIssues={
                              sendInformationViewIssues
                            }
                            calcStatus={calcStatus}
                            onShowModal={onShowModal}
                            index={index}
                            category={category}
                          />
                        )
                      )
                    ) : <NoContent />}
                  {/* // {renderVendorOpenIssueTablebody()} */}
                </Table>
              </div>
              {filterSearch.length > 0 ? (
                <BasicPagination
                  totalRecords={filterSearch.length}
                  limit={10}
                  batch={page}
                  onBatchChange={(e) => handleBatchChange(e)}
                />
              ) : (
                <> </>
              )}
            </div>
          </div>
        </div>
      </div>
      <StatusModal
        modalStatus={modalStatus}
        statusTypes={statusTypes}
        onCloseModal={onCloseModal}
        onChangeTempStatus={onChangeTempStatus}
        currentStatus={currentStatus}
        onSubmitHandler={onSubmitHandler}
      />
    </React.Fragment>
  );
};

SuperAdminOpenIssuesVendor.propTypes = {
  admin_vendors_issue: PropTypes.array.isRequired,
  auth: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  admin_vendors_issue: state.adminAllVendorsInfo.superAdminOpenIssuesVendor,
  auth: state.auth,
  errors: state.errors.errors,
});

export default connect(mapStateToProps, {
  clear_all_errors,
  superadmin_vendor_open_issue,
  superadmin_vendor_Single_open_issue,
  update_super_admin_open_issues,
})(withRouter(SuperAdminOpenIssuesVendor));
